import { create } from 'zustand';

const useBreadcrumbStore = create((set) => ({
  breadcrumbs: [],
  setBreadcrumbs: (breadcrumbs) => set({ breadcrumbs })
}));

export default useBreadcrumbStore;